import * as React from "react";
import { forwardRef } from "react";
const SvgDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 7 5", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.90892 4.70814C3.74911 4.89748 3.45737 4.89748 3.29756 4.70814L0.555296 1.45908C0.335799 1.19901 0.520662 0.801081 0.860973 0.801081L6.34551 0.801082C6.68582 0.801082 6.87068 1.19902 6.65118 1.45908L3.90892 4.70814Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDown);
export default ForwardRef;
